import {Injectable} from '@angular/core';
import {
  FieldService,
  ResponsiveService,
  ValidationService
} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';
import {validationRules} from '@constants/validation-rules.constants';

@Injectable({
  providedIn: 'root'
})
export class CoreConfigService {

  constructor(
    private validationService: ValidationService,
    private responsiveService: ResponsiveService,
    private fieldService: FieldService
  ) {
  }

  initConfig(): void {
    this.validationService.setRules(validationRules);
    this.validationService.setShowRuleErrorForNotNull(true);
    this.validationService.setShowRuleErrorOutsideIconMobile(true);
    this.validationService.setShowRuleErrorOutsideIconTablet(true);
    this.validationService.setShowRuleErrorOutsideIconDesktop(true);
    this.responsiveService.setCurrentWindowWidth(window.visualViewport.width);
    this.fieldService.setInputUpdateNgModelOnBlur(true);
    this.fieldService.setMultilineUpdateNgModelOnBlur(true);
    this.fieldService.setSelectorResponsiveTemplate(true);
    this.fieldService.setSelectorMultipleResponsiveTemplate(true);
  }
}
